import * as S from './styles';
import { useState } from 'react';
import { Input, Select, message, Tabs, Button, Popconfirm, Space } from 'antd';
import editClientService from 'services/client/createClient';
import updatePortalPassword from 'services/client/updatePortalPassword';
import { FaEdit, FaTrash } from "react-icons/fa";
import { CopyOutlined, MailOutlined, PlusOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { linkEmail, linkWhatsapp, mensagemAcessoPortal } from 'utils/contato';
import { getUserCachedData } from 'utils/UserAuthorization';
import ClientsDocuments from '../DocClient';
import { isAdmin } from 'utils/permissions';
import { getErrorMessage } from 'utils/errorMessage';
const { TabPane } = Tabs;

const { Option } = Select;

function EditClient({
  icon,
  clientData,
  newClient,
  successCallback,
  // props opcionais para controle externo do drawer
  open, // boolean | undefined
  onOpenChange, // function
}) {
  // Função de deletar cliente (placeholder)
  const handleDelete = () => {
    // Aqui você pode chamar o serviço de deletar cliente
    message.success('Cliente deletado!');
  setDrawerOpen(false);
    // TODO: Chamar callback de sucesso se necessário
  };
  const [internalOpen, setInternalOpen] = useState(false)
  const isControlled = typeof open === 'boolean'
  const drawerOpen = isControlled ? open : internalOpen
  const userIsAdmin = isAdmin()
  const setDrawerOpen = value => {
    if (isControlled) {
      onOpenChange && onOpenChange(value)
    } else {
      setInternalOpen(value)
    }
  }
  const [clientEdit, setClientForm] = useState({
    id: clientData?.id,
    nome: clientData?.nome,
    rg: clientData?.rg,
    orgao_emissor: clientData?.orgao_emissor,
    cpf: clientData?.cpf,
    estado_civil: clientData?.estado_civil || clientData?.estadoCivil,
    endereco: clientData?.endereco,
    bairro: clientData?.bairro,
    cidade: clientData?.cidade,
    uf: clientData?.uf,
    telefones: clientData?.telefones,
    email: clientData?.email,
    portalPassword: clientData?.portalPassword,
    nacionalidade: clientData?.nacionalidade,
    profissao: clientData?.profissao,
    consulta_valor: clientData?.consulta_valor,
    plano_valor: clientData?.plano_valor,
    informacoes_caso: clientData?.informacoes_caso
  });

  const [incorrectInfo, setIncorrectInfo] = useState(false);
  const [incorrectPhrase, setIncorrectPhrase] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const EditClient = async () => {
    if (isSaving) return;

    const isNotEmpty =
      Boolean(String(clientEdit?.nome ?? '').trim()) &&
      Boolean(String(clientEdit?.cpf ?? '').trim());

    if (isNotEmpty) {
      setIsSaving(true);
      try {
        const payload = {
          ...clientEdit,
          cpf: formatarDocumento(clientEdit.cpf)
        };

        await editClientService(payload);
        successCallback && successCallback();
        message.success(`Cliente ${payload?.nome} ${newClient ? "criado" : "editado"} com sucesso!`);
        setDrawerOpen(false);
        setClientForm({});
      } catch (error) {
        // formatarDocumento já avisou: não soma um segundo erro genérico
        if (error?.message === 'Documento inválido') return;

        const errorData = error?.response?.data;
        const duplicateConstraintMessage = "Erro: duplicate key value violates unique constraint";

        if (typeof errorData === 'string' && errorData.includes(duplicateConstraintMessage)) {
          message.error("Cliente já registrado");
        } else {
          message.error(getErrorMessage(error, 'Erro ao salvar cliente. Tente novamente.'));
        }

        setIncorrectInfo(true);
        setIncorrectPhrase('Verifique os dados inseridos.');
      } finally {
        setIsSaving(false);
      }
    } else {
      setIncorrectInfo(true);
      setIncorrectPhrase('Não podem haver campos vazios.');
      return message.error("Preencha o nome e o CPF ou CNPJ do contato.")
    }
  };

  const handleCancel = () => {
    if (isSaving) return;
    setDrawerOpen(false);
  };

  const mensagemAcesso = () => mensagemAcessoPortal({
    nome: clientEdit.nome,
    cpf: clientEdit.cpf,
    senha: clientEdit.portalPassword,
    escritorio: getUserCachedData()?.company?.nome,
  });

  const generatePortalPassword = async () => {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';
    let pass = '';
    for (let i = 0; i < 8; i++) {
      pass += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    if (!clientData?.id) {
      setClientForm(prev => ({ ...prev, portalPassword: pass }));
      navigator.clipboard?.writeText(pass).catch(() => {});
      message.info('Senha gerada. Salve o novo cliente para ativá-la no portal.');
      return;
    }

    setIsSaving(true);
    try {
      await updatePortalPassword(clientData.id, pass);
      setClientForm(prev => ({ ...prev, portalPassword: pass }));
      navigator.clipboard?.writeText(pass).catch(() => {});
      message.success('Nova senha salva e copiada. Envie esta senha ao cliente.');
    } catch (error) {
      message.error(getErrorMessage(error, 'Não foi possível salvar a nova senha.'));
    } finally {
      setIsSaving(false);
    }
  };

  function formatarDocumento(doc) {
    // Verifica se doc está definido
    if (!doc) {
      message.error("Documento inválido");
      throw new Error("Documento inválido");
    }
    doc = doc.replace(/\D/g, '');
    if (doc.length === 11) {
      return formatarCPF(doc);
    } else if (doc.length === 14) {
      return formatarCNPJ(doc);
    } else {
      message.error("Documento inválido");
      throw new Error("Documento inválido");
    }
  }

  function formatarCPF(cpf) {
    if (cpf.length !== 11) {
      message.error("CPF inválido");
      throw new Error("CPF inválido");
    }
    return cpf.slice(0, 3) + '.' + cpf.slice(3, 6) + '.' + cpf.slice(6, 9) + '-' + cpf.slice(9);
  }

  function formatarCNPJ(cnpj) {
    if (cnpj.length !== 14) {
      message.error("CNPJ inválido");
      throw new Error("CNPJ inválido");
    }
    return cnpj.slice(0, 2) + '.' + cnpj.slice(2, 5) + '.' + cnpj.slice(5, 8) + '/' + cnpj.slice(8, 12) + '-' + cnpj.slice(12);
  }
  

  return (
    <>
      <S.DrawerFooterStyles>
      <S.EditClientDrawer
        title={newClient ? 'Novo contato' : 'Editar contato'}
        open={drawerOpen}
        mask={false}
        push={{ distance: 70600  }}
        onCancel={handleCancel}
        onClose={handleCancel}
        closable={!isSaving}
        maskClosable={!isSaving}
        footer={
          <div style={{ display: 'flex', alignItems: 'center', width: '100%', height: "5vh" }}>
            <div>
              {!newClient && userIsAdmin && (
                <Popconfirm title="Tem certeza que deseja deletar este cliente?" onConfirm={handleDelete} okText="Sim" cancelText="Não" disabled={isSaving}>
                  <Button danger size="large" icon={<FaTrash />} style={{ marginRight: 8 }} disabled={isSaving}>
                    Deletar
                  </Button>
                </Popconfirm>
              )}
            </div>
            <div style={{ display: 'flex', width: '100%', alignItems: 'center',height: "5vh"}}>
              <Button
                key="submit"
                type="primary"
                className="drawer-primary-btn"
                onClick={EditClient}
                loading={isSaving}
                disabled={isSaving}
                style={{ flex: 1, alignSelf: "center", opacity: isSaving ? 0.65 : 1 }}
              >
                {isSaving ? 'Salvando...' : newClient ? 'Salvar' : 'Atualizar'}
              </Button>
            </div>
          </div>
        }
      >
        <Tabs defaultActiveKey="1" style={{ marginBottom: 24 }}>
          <TabPane tab="Editar" key="1">
            <S.Container>
            <S.EditClientForm>
          <S.EditClientInputGroup>
            <S.Flex>
              <S.EditClientInput>
                <label htmlFor='nome'>
                  <S.LabelTitle>Nome</S.LabelTitle>
                </label>
                <Input
                  type='text'
                  value={clientEdit.nome}
                  onChange={e =>
                    setClientForm(prev => ({ ...prev, nome: e.target.value }))
                  }
                  onClick={() => setIncorrectInfo(false)}
                  id='nome'
                />
              </S.EditClientInput>
              <S.EditClientInput>
                <label htmlFor='cpf'>
                  <S.LabelTitle>CPF/CNPJ</S.LabelTitle>
                </label>

                <Input
                  type='text'
                  value={clientEdit.cpf}
                  onChange={e =>
                    setClientForm(prev => ({ ...prev, cpf: e.target.value }))
                  }
                  onClick={() => setIncorrectInfo(false)}
                  id='cpf'

                  placeholder="000.000.000-00"
                >

                </Input>
              </S.EditClientInput>


            </S.Flex>
          </S.EditClientInputGroup>

          <S.EditClientInputGroup>
            <S.Flex>
              <S.EditClientInput>
                <label htmlFor='rg'>
                  <S.LabelTitle>RG</S.LabelTitle>
                </label>
                <Input
                  type='text'
                  value={clientEdit.rg}
                  onChange={e =>
                    setClientForm(prev => ({ ...prev, rg: e.target.value }))
                  }
                  onClick={() => setIncorrectInfo(false)}
                  id='rg'
                />
              </S.EditClientInput>
              <S.EditClientInput>
                <label htmlFor='orgao_emissor'>
                  <S.LabelTitle>Órgão Emissor</S.LabelTitle>
                </label>
                <Input
                  type='text'
                  value={clientEdit.orgao_emissor}
                  onChange={e =>
                    setClientForm(prev => ({ ...prev, orgao_emissor: e.target.value }))
                  }
                  onClick={() => setIncorrectInfo(false)}
                  id='orgao_emissor'
                />
              </S.EditClientInput>

            </S.Flex>
          </S.EditClientInputGroup>

          <S.EditClientInputGroup>
            <S.Flex>
              <S.EditClientInput>
                <label htmlFor='estado_civil'>
                  <S.LabelTitle>Estado Civil</S.LabelTitle>
                </label>
                <Select
                  value={clientEdit.estado_civil}
                  onChange={value =>
                    setClientForm(prev => ({ ...prev, estado_civil: value }))
                  }
                  style={{ width: '100%' }}
                  placeholder="Selecione um estado civil"
                >
                  <Option value="Solteiro(a)">Solteiro(a)</Option>
                  <Option value="Casado(a)">Casado(a)</Option>
                  <Option value="Divorciado(a)">Divorciado(a)</Option>
                  <Option value="Viúvo(a)">Viúvo(a)</Option>
                </Select>
              </S.EditClientInput>
              <S.EditClientInput>
                <label htmlFor='nacionalidade'>
                  <S.LabelTitle>Nacionalidade</S.LabelTitle>
                </label>
                <Input
                  type='text'
                  value={clientEdit.nacionalidade}
                  onChange={e =>
                    setClientForm(prev => ({ ...prev, nacionalidade: e.target.value }))
                  }
                  onClick={() => setIncorrectInfo(false)}
                  id='nacionalidade'
                  placeholder="Ex: Brasileira"
                />
              </S.EditClientInput>
            </S.Flex>
          </S.EditClientInputGroup>

          <S.EditClientInputGroup>
            <S.Flex>
              <S.EditClientInput>
                <label htmlFor='profissao'>
                  <S.LabelTitle>Profissão</S.LabelTitle>
                </label>
                <Input
                  type='text'
                  value={clientEdit.profissao}
                  onChange={e =>
                    setClientForm(prev => ({ ...prev, profissao: e.target.value }))
                  }
                  onClick={() => setIncorrectInfo(false)}
                  id='profissao'
                  placeholder="Ex: Advogado"
                />
              </S.EditClientInput>
              <S.EditClientInput>
                <label htmlFor='endereco'>
                  <S.LabelTitle>Endereço</S.LabelTitle>
                </label>
                <Input
                  type='text'
                  value={clientEdit.endereco}
                  onChange={e =>
                    setClientForm(prev => ({ ...prev, endereco: e.target.value }))
                  }
                  onClick={() => setIncorrectInfo(false)}
                  id='endereco'
                />
              </S.EditClientInput>
            </S.Flex>
          </S.EditClientInputGroup>

          <S.EditClientInputGroup>
            <S.Flex>
              <S.EditClientInput>
                <label htmlFor='bairro'>
                  <S.LabelTitle>Bairro</S.LabelTitle>
                </label>
                <Input
                  type='text'
                  value={clientEdit.bairro}
                  onChange={e =>
                    setClientForm(prev => ({ ...prev, bairro: e.target.value }))
                  }
                  onClick={() => setIncorrectInfo(false)}
                  id='bairro'
                />
              </S.EditClientInput>
              <S.EditClientInput>
                <label htmlFor='cidade'>
                  <S.LabelTitle>Cidade</S.LabelTitle>
                </label>
                <Input
                  type='text'
                  value={clientEdit.cidade}
                  onChange={e =>
                    setClientForm(prev => ({ ...prev, cidade: e.target.value }))
                  }
                  onClick={() => setIncorrectInfo(false)}
                  id='cidade'
                />
              </S.EditClientInput>
            </S.Flex>
          </S.EditClientInputGroup>

          <S.EditClientInputGroup>
            <S.Flex>
              <S.EditClientInput>

                <label htmlFor='uf'>
                  <S.LabelTitle>UF</S.LabelTitle>
                </label>
                <Select
                  value={clientEdit.uf}
                  onChange={value =>
                    setClientForm(prev => ({ ...prev, uf: value }))
                  }
                  style={{ width: '100%' }}
                  placeholder="Selecione uma UF"
                >
                  {[
                    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT',
                    'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO',
                    'RR', 'SC', 'SP', 'SE', 'TO'
                  ].map(uf => (
                    <Option key={uf} value={uf}>{uf}</Option>
                  ))}
                </Select>
              </S.EditClientInput>
              <S.EditClientInput>
                <label htmlFor='telefone'>
                  <S.LabelTitle>Telefone</S.LabelTitle>
                </label>
                <Input
                  type='text'
                  value={clientEdit.telefones}
                  onChange={e =>
                    setClientForm(prev => ({ ...prev, telefones: e.target.value }))
                  }
                  onClick={() => setIncorrectInfo(false)}
                  id='telefone'
                >
                </Input>
              </S.EditClientInput>
            </S.Flex>
          </S.EditClientInputGroup>

          <S.EditClientInputGroup>
            <S.Flex>
              <S.EditClientInput>
                <label htmlFor='email'>
                  <S.LabelTitle>Email</S.LabelTitle>
                </label>
                <Input
                  type='email'
                  value={clientEdit.email}
                  onChange={e =>
                    setClientForm(prev => ({ ...prev, email: e.target.value }))
                  }
                  onClick={() => setIncorrectInfo(false)}
                  id='email'
                />
              </S.EditClientInput>
              <S.EditClientInput>
                <label htmlFor='consulta_valor'>
                  <S.LabelTitle>Valor da Consulta</S.LabelTitle>
                </label>
                <Input
                  type='number'
                  value={clientEdit.consulta_valor}
                  onChange={e =>
                    setClientForm(prev => ({ ...prev, consulta_valor: e.target.value }))
                  }
                  onClick={() => setIncorrectInfo(false)}
                  id='consulta_valor'
                />
              </S.EditClientInput>
            </S.Flex>
          </S.EditClientInputGroup>

          <S.EditClientInputGroup>
            <S.Flex>
              <S.EditClientInput>
                <label htmlFor='plano_valor'>
                  <S.LabelTitle>Valor do Plano</S.LabelTitle>
                </label>
                <Input
                  type='number'
                  value={clientEdit.plano_valor}
                  onChange={e =>
                    setClientForm(prev => ({ ...prev, plano_valor: e.target.value }))
                  }
                  onClick={() => setIncorrectInfo(false)}
                  id='plano_valor'
                />
              </S.EditClientInput>
            </S.Flex>
          </S.EditClientInputGroup>

          <S.EditClientInputGroup>
            <S.Flex>
              <S.EditClientInput>
                <label htmlFor='portalPassword'>
                  <S.LabelTitle>Senha Portal do Cliente</S.LabelTitle>
                </label>
                <Input
                  type='text'
                  value={clientEdit.portalPassword}
                  placeholder={clientData?.id ? 'Senha protegida — redefina para reenviar' : 'Gere uma senha para o portal'}
                  onChange={e =>
                    setClientForm(prev => ({ ...prev, portalPassword: e.target.value }))
                  }
                  id='portalPassword'
                  addonAfter={
                    <Popconfirm
                      title="Redefinir a senha do portal?"
                      description="A senha anterior deixará de funcionar. A nova será salva e copiada."
                      onConfirm={generatePortalPassword}
                      okText="Redefinir"
                      cancelText="Cancelar"
                      disabled={isSaving}
                    >
                      <Button
                        type="primary"
                        loading={isSaving}
                        disabled={isSaving}
                        size="small"
                      >
                        {clientData?.id ? 'Redefinir e copiar' : 'Gerar e copiar'}
                      </Button>
                    </Popconfirm>
                  }
                />
                {clientEdit.portalPassword && (
                  // envia o acesso pronto: link do portal, login (CPF) e a senha
                  <Space wrap size={8} style={{ marginTop: 8 }}>
                    {linkWhatsapp(clientEdit.telefones, mensagemAcesso()) && (
                      <Button size='small' icon={<WhatsAppOutlined />} href={linkWhatsapp(clientEdit.telefones, mensagemAcesso())} target='_blank' rel='noreferrer'>
                        Enviar acesso pelo WhatsApp
                      </Button>
                    )}
                    {linkEmail(clientEdit.email) && (
                      <Button size='small' icon={<MailOutlined />} href={linkEmail(clientEdit.email, 'Acesso ao Portal do Cliente', mensagemAcesso())}>
                        Enviar por e-mail
                      </Button>
                    )}
                    <Button size='small' icon={<CopyOutlined />} onClick={() => { navigator.clipboard?.writeText(mensagemAcesso()); message.success('Mensagem de acesso copiada.') }}>
                      Copiar mensagem
                    </Button>
                  </Space>
                )}
                {clientData?.id && !clientEdit.portalPassword && (
                  <small style={{ display: 'block', marginTop: 6, color: 'var(--yrm-text-3)' }}>
                    Por segurança, a senha atual não é exibida. Se o cliente esquecer, redefina e envie a nova senha.
                  </small>
                )}
              </S.EditClientInput>
            </S.Flex>
          </S.EditClientInputGroup>

          {/* Campo de Informações Adicionais */}
          <S.EditClientInputGroup>
            <S.Flex>
              <S.EditClientInput>
                <label htmlFor='informacoes_caso'>
                  <S.LabelTitle>Informações do Caso</S.LabelTitle>
                </label>

                <Input.TextArea
                  rows={10}
                  spellCheck={true}
                  style={{ width: '500px' }}
                  value={clientEdit.informacoes_caso}
                  placeholder="Digite as informações do caso aqui"
                  onChange={e =>
                    setClientForm(prev => ({ ...prev, informacoes_caso: e.target.value }))
                  }
                  onClick={() => setIncorrectInfo(false)}
                  id='informacoes_caso'
                />
              </S.EditClientInput>
            </S.Flex>
          </S.EditClientInputGroup>

          {/* Exibir mensagem de erro se houver informações incorretas */}
          {incorrectInfo && <S.EditClientError>{incorrectPhrase}</S.EditClientError>}

            </S.EditClientForm>
            </S.Container>
          </TabPane>
          <TabPane tab="Documentos" key="2">
            <ClientsDocuments clientId={clientData?.id} />
          </TabPane>
        </Tabs>
  </S.EditClientDrawer>
  </S.DrawerFooterStyles>

  {newClient ? (
    <Button type='primary' size='large' icon={<PlusOutlined />} onClick={() => setDrawerOpen(true)}>
      Novo contato
    </Button>
  ) : (
    <Button 
      type='text' 
      size='small' 
      onClick={() => setDrawerOpen(true)}
      title="Editar contato"
      style={{ 
        border: 'none', 
        background: 'transparent',
        padding: 0,
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {icon || <FaEdit size={16} />}
    </Button>
  )}
    </>
  );
}

export default EditClient;
